export default "__VITE_ASSET__acdfb8fe__"